import * as qs from 'qs'

import { getClientSecret } from 'core-components/sitebuilder/helpers/getClientSecret'
import { getTokens } from 'core-components/sitebuilder/helpers/getTokens'
import { IUser } from 'core-components/sitebuilder/models/IUser'

interface IGetRemoteUrl {
  src: string | undefined
  queryParams: { [key: string]: string }
  ownerId: string
  appId: string
  user?: IUser
}

export const getRemoteUrl = ({ src, queryParams, user, ownerId, appId }: IGetRemoteUrl): string => {
  let urlParams = {}
  if (src && src.indexOf('?') !== -1) {
    let paramsString = src.substring(src.indexOf('?') + 1)
    if (paramsString.length) {
      if (user?.email) {
        paramsString = paramsString.replace('{{Email}}', user.email)
      }

      if (user?.email) {
        paramsString = paramsString.replace('{{AppId}}', appId)
      }

      const [accessToken, refreshToken] = getTokens(ownerId)
      if (accessToken) {
        paramsString = paramsString.replace('{{Token}}', accessToken)
      }

      if (refreshToken) {
        paramsString = paramsString.replace('{{RefreshToken}}', refreshToken)
      }

      const [clientId, secretId] = getClientSecret(ownerId)

      if (clientId) {
        paramsString = paramsString.replace('{{ClientId}}', clientId)
      }

      if (secretId) {
        paramsString = paramsString.replace('{{SecretId}}', secretId)
      }

      for (const key in queryParams) {
        if (queryParams.hasOwnProperty(key) && key !== 'iframeSrc') {
          paramsString = paramsString.replace(`{{${key}}}`, queryParams[key])
        }
      }

      urlParams = qs.parse(paramsString)
    }
  }

  const nextParams = { ...urlParams, ...queryParams }
  delete nextParams['iframeSrc']
  const query = Object.keys(nextParams).length ? qs.stringify(nextParams) : ''
  let url = src || ''
  if (url.indexOf('?') !== -1) {
    url = url.substring(0, url.indexOf('?'))
  }
  return query ? `${url}?${query}` : url
}
